<section id="our-purity-standard">
    <div class="top-banner-section">
        <div class="heading"><span class="text1">OUR</span><span class="text2"> Promise</span><span class="text3"> TO YOU</span></div>
    </div>
    <div class="second-section-purium-profile">
        <div class="heading">At Purium, quality is not just a standard—it’s our mission, our passion, and the very foundation of who we are.</div>
        <div class="sub-heading">Derived from the words "Pure" and "Premium," the name Purium embodies our unwavering commitment to providing the highest-quality superfoods that nourish the body and transform lives.</div>
        <div class="para">
            Founded by visionary leaders Dave Sandoval and Amy Venner, Purium was born from a shared belief in the natural power of whole foods and a deep desire to help people reclaim their health and restore the environment. Over two decades ago, Dave and Amy set out to create a company that would empower individuals with the opportunities to lead healthier, happier and more vibrant lives. Today, that vision continues to inspire everything we do.
        </div>
    </div>
    <div class="third-section-purium-standard">
         <div class="heading">the purium standard</div>
         <div class="sub-heading">Pure, Clean, and Uncompromising</div>
         <div class="ingredients-section">
              <div class="left-section">
                 <div class="top-div">
                     <div class="heading">Pure Ingredients</div>
                     <div class="para">We believe in the power of nature. That’s why every ingredient in our products is thoughtfully chosen for its purity, potency, and purpose. We partner with organic, non-GMO, and sustainably-focused farmers to ensure that only the best finds its way into your hands—and your body.</div>
                 </div>
                 <div class="bottom-div mt-4">
                     <div class="heading">Rigorous Testing</div>
                     <div class="para">Your health and safety are our top priorities. Every batch of our products undergoes extensive testing for potency, purity, and nutritional consistency. This ensures you receive only the finest quality with every order.</div>
                 </div>
              </div>
              <div class="center-section">
                  <div class="circle">
                     <div class="image-div">

                     </div>
                  </div>
              </div>
              <div class="right-section">
                <div class="top-div">
                    <div class="heading">No Compromises</div>
                    <div class="para">We say no to artificial additives, fillers, and synthetic ingredients—always. When you choose Purium, you’re choosing products that are as close to nature as possible, created with nothing but the good stuff your body needs and deserves.</div>
                </div>
                <div class="bottom-div mt-4">
                    <div class="heading">Clean Manufacturing</div>
                    <div class="para">From farm to finish, we uphold the highest standards of cleanliness, efficiency, and integrity. Our state-of-the-art facilities are certified for excellence, ensuring that every scoop, capsule, and powder you receive is as safe and effective as it is nourishing.</div>
                </div>
              </div>
         </div>
    </div>
    <div class="fourth-section-purium-testing-analysis">
                <div class="testing-analysis-points">
                    <div class="heading">Purium testing includes analysis for:</div>
                    <div class="points">
                        <div class="left-points">
                            <ul>
                              <li>Staph</li>
                              <li>Salmonella</li>
                              <li>E. coli</li>
                              <li>Coliform bacteria</li>
                              <li>Other microbial indicator organisms</li>
                            </ul>
                        </div>
                        <div class="right-points">
                            <ul>
                               <li>Heavy metal contaminants such as arsenic, lead, cadmium, and mercury.</li>
                               <li>Gluten</li>
                               <li>Pesticides and other contaminants</li>
                               <li>Potency (if applicable)</li>
                            </ul>
                        </div>
                    </div>
               </div>
    </div>
    <div class="fifth-section-customer-reviews">
         <div class="reviews">
             <div class="heading">Customer Reviews</div>
             <div class="left-quote">
                <img src="assets/images/our-purity-standard/left-quote.svg" alt="">
             </div>
             <div class="carousel-container mt-4">
                <ngx-slick-carousel 
                #slickModal="slick-carousel" 
                [config]="slideConfig" 
                class="carousel customCarousel">
                <div ngxSlickItem *ngFor="let slide of purium_reviews" class="slide">
                    <div class="testimonial-card">
                        <div class="review-heading">{{slide.review_heading}}</div>
                        <div class="review-text">{{slide.review_text}}</div>
                        <div class="reviewer-name">
                            <span>-</span> {{slide.name}}
                         </div>
                         <div class="navigation-arrows">
                            <button (click)="slickModal.slickPrev()" class="arrow-btn">←</button>
                            <button (click)="slickModal.slickNext()" class="arrow-btn">→</button>
                        </div>
                    </div>
                </div>
               </ngx-slick-carousel>
             </div>
         </div>
    </div>
    <div class="sixth-section-purity-quality-commitment">
        <div class="points-section">
            <div class="quality-commitment-points">
                <div class="heading">10 Point Quality Commitment</div>
                 <ul>
                    <li>Certified Organic Farmers</li>
                    <li>Regenerative Farming Practices</li>
                    <li>Synergistically Combined Formulas</li>
                    <li>On-site Microbiology Department</li>
                    <li>Ingredient Identification Testing</li>
                    <li>Allergen Program/Gluten Testing</li>
                    <li>OK Certified Kosher</li>
                    <li>QAI Certified Organic</li>
                    <li>GMP FDA Registered Facility</li>
                    <li>60-Day Money Back Guarantee</li>
                 </ul>
             </div>
             <div class="image">
                 <img src="assets/images/our-purity-standard/purity-quality-image.png" alt="">
             </div>
             <div class="purity-commitment-points">
                  <div class="heading">10 Point Purity Commitment</div>
                  <ul>
                    <li>No Artificial Colors</li>
                    <li>No Artificial Flavors</li>
                    <li>No Artificial Sweeteners</li>
                    <li>No Synthetic Vitamins</li>
                    <li>No Binders</li>
                    <li>No Fillers</li>
                    <li>No GMO's</li>
                    <li>No Pesticides</li>
                    <li>No Herbicides</li>
                    <li>Plastic Free Packaging</li>
                  </ul>
             </div>
        </div>
    </div>
    <div class="seventh-section-customer-testimonials">
        <div class="heading">Life-changing Superfoods</div>
        <div class="left-quote mt-4 mb-5 text-center">
            <img src="assets/images/our-purity-standard/left-quote.svg" alt="">
        </div>
        <div class="testimonial-grid">
            <div class="testimonial-card">
                <div class="title">Not just another "green juice" like other store bought brands.</div>
                <p class="content">
                  Power Shake is known by many of our Health Gurus as Liquid Sunshine!
                </p>
                <p class="content">
                  More than just verified, Organic means no pesticide residue in any of these superfood ingredients.
                  The vitamins come from REAL FOOD, and God's FOOD IS MEDICINE.
                </p>
                <p class="content">
                  A full serving of veggies, fiber, grasses, and healthy fats, it tastes amazing, like Apple Berry.
                  Nourishes and satiates like a meal and fuels your cells, helping you make better food choices throughout the day.
                  Cannot imagine life without this Liquid Sunshine that fuels my soul. I crave it every day!
                </p>

                <div class="profile">
                    <img src="assets/images/our-purity-standard/Dominique.png" alt="Dominique" class="avatar">
                    <span class="name">-Dominique</span>
                </div>
            </div>
            <div class="testimonial-card">
                <div class="title">Why Purium is not like other “powders:</div>
                <p class="content">
                    Why Purium is not like other “powders:” We are organic, regenerative, grown, whole food superfoods, raw, and dehydrated to preserve maximum living enzymes and benefits. We have the best gut repair on the market too! The body heals itself when we create the right environment, and that’s just what this lifestyle does.
                </p>

                <div class="profile">
                    <img src="assets/images/our-purity-standard/Allison-and-Jared.png" alt="Dominique" class="avatar">
                    <span class="name">-Allison and Jared </span>
                </div>
            </div>
            <div class="testimonial-card">
                <p class="content">
                    I have achieved a level of health and wellness that far surpasses anything I ever expected. Not only on the physical level but also on the mental and spiritual side. Taking care of myself and my family in an honest way that brings results is so satisfying. It feels so good to believe in the company that I am partnered with and to provide quality solutions to people that I love.
                </p>

                <div class="profile">
                    <img src="assets/images/our-purity-standard/Amber.jpg" alt="Dominique" class="avatar">
                    <span class="name">-Amber</span>
                </div>
            </div>
            <div class="testimonial-card">
                <p class="content">
                    All of these products are certified organic, regeneratively, farmed, third-party tested, gluten-free, free of artificial flavors, sweeteners, or fillers, and absolutely no GMOs or pesticides. This company has been helping people optimize their health for over 20 years. I only wish I found them sooner.
                </p>

                <div class="profile">
                    <img src="assets/images/our-purity-standard/Nichole.png" alt="Dominique" class="avatar">
                    <span class="name">-Nichole</span>
                </div>
            </div>
            <div class="testimonial-card">
                <div class="title">The certified organic green superfood shake is just one component . . . and it is ENERGIZING and DELICIOUS!!</div>
                <p class="content">
                    Add to that high-quality protein, gut support, sleep support, and a parasite cleanse, and you’ve got a comprehensive program that will move the needle in your health and vitality!
                </p>

                <div class="profile">
                    <img src="assets/images/our-purity-standard/Sonia.jpg" alt="Dominique" class="avatar">
                    <span class="name">-Sonia</span>
                </div>
            </div>
            <div class="testimonial-card">
                <p class="content">
                    I am obsessed with this superfood greens drink which is packed with microgreens, wheatgrass, spirulina, sprouts, fiber, and more. It’s part of a gut reset program I’ve been using and recommending to hundreds of clients to regenerate their gut health, improve absorption, and nourish their bodies from the inside out.
                </p>

                <div class="profile">
                    <img src="assets/images/our-purity-standard/Carolina.png" alt="Dominique" class="avatar">
                    <span class="name">-Carolina</span>
                </div>
            </div>
        </div>
    </div>
    <div class="eighth-section-analysis-certificate">
         <div class="image-section">
             <div class="content">View Our Certificate of Analyses</div>
         </div>
         <div class="content-div">
          <p>
             Producing a scientific Certificate of Analysis (COA) is not a simple thing as there are a multitude of quality assurance tests that are required for the production of each Purium product. We test incoming raw materials, as well as “blends” in progress at critical control points during the manufacturing process. One final test ensures quality just prior to the product’s release. In addition to these tests, we also conduct shelf life tests to make sure your products are fresh and nutritious to the last serving, so long as they are used within our recommended dates.
          </p>
          <p>
             Compiling all of this information in entirety for each lot number of products is not plausible as test documents and data are reviewed, processed, and filed at various stages of the manufacturing. However, we have done our best to provide the most commonly requested and relevant information on our C of A’s, including heavy metal analysis.
          </p>
          <p>
             If you would like to see our Certificates, click the links below. These documents are typically used by a very niche audience of internal supply chain and quality personnel, with extensive training.
          </p>
        </div>
    </div>
    <div class="ninth-section-our-certificates-of-analysis">
        <div class="heading">Our Certificates of Analysis</div>
        <div class="menu-section" *ngIf="!enrollSessionService.mobileViewMethod()">
             <div class="left-menu">
                <div class="scroller" #scrollBarContainer>
                    <div class="scrolling-div">
                        <div class="scroll-icon" #scrollIcon></div>
                    </div>
                 <button  #menuBtn class="menu-btn" *ngFor="let item of analysisCertificates; let i = index" [ngClass]="{'active': selectedCertificate?.changingThisBreaksApplicationSecurity === item.certificate}"  
                  (click)="selectCertificate(item.certificate, i)">{{item.menu_heading}}</button>
                </div>
             </div>
             <!-- <div class="scroller">
                 <div class="scroll-icon" #scrollIcon></div>
             </div> -->
             <div class="certificate-img">
                <!-- <object *ngIf="selectedCertificate" [data]="selectedCertificate" type="application/pdf" width="100%" height="100%">
                    <p>Your browser does not support PDFs. 
                        <a [href]="selectedCertificate" target="_blank">Download Certificate</a>
                    </p>
                </object> -->
                <iframe *ngIf="selectedCertificate" [src]="selectedCertificate" width="100%" height="100%"></iframe>
             </div>
        </div>

        <div class="menu-section" *ngIf="enrollSessionService.mobileViewMethod()">
            <div class="left-menu">
                <button  class="menu-btn" *ngFor="let item of analysisCertificates; let i = index" [ngClass]="{'active': selectedCertificate?.changingThisBreaksApplicationSecurity === item.certificate}"  
                 (click)="selectCertificate(item.certificate, i)">{{item.menu_heading}}</button>
            </div>
            <!-- <div class="scroller">
                <div class="scroll-icon" #scrollIcon></div>
            </div> -->
            <div class="certificate-img">
               <!-- <object *ngIf="selectedCertificate" [data]="selectedCertificate" type="application/pdf" width="100%" height="100%">
                   <p>Your browser does not support PDFs. 
                       <a [href]="selectedCertificate" target="_blank">Download Certificate</a>
                   </p>
               </object> -->
               <iframe *ngIf="selectedCertificate" [src]="selectedCertificate" width="100%" height="100%"></iframe>
            </div>
       </div>
    </div>

    <div class="tenth-section-faq-section">
        <div class="heading">Frequently Asked Question</div>
        <div class="faq-accordion">
          <div class="accordion" *ngFor="let item of items; let i = index">
            <div class="accordion-header" (click)="toggleAccordion(i)" [ngClass]="(activeIndex === i)? 'minus-background': 'plus-background'">
              <span *ngIf="activeIndex === i" class="image-and-text"><img src="assets/images/our-purity-standard/question-bulb-white.svg" class="bulb-icon" alt="bulb icon" />  {{ item.title }}</span>
              <span *ngIf="!(activeIndex === i)" class="image-and-text"><img src="assets/images/our-purity-standard/question-bulb-green.svg" class="bulb-icon" alt="bulb icon" />  {{ item.title }}</span>
              <span class="icon" [ngClass]="(activeIndex === i) ? 'minus' : 'plus'">{{ activeIndex === i ? 'remove' : 'add' }}</span>
            </div>
            <div class="accordion-content" *ngIf="activeIndex === i">
              <ng-container *ngFor="let list of item.content">
                  <p> {{ list.innerText }}</p>
              </ng-container>
            </div>
          </div>
        </div>
         <div class="container smallScreenPadding view-more-faq-btn">
            <a href="" class="main-btn ult-btn">
                <div>view more faqs</div>
                <img class="" [src]="IMAGE_URL+'/icons/YellowLineArrow.png'" width="50" alt="">
            </a>
         </div>
    </div>

    <div class="eleventh-section-guided-by-purpose">
         <div class="content">
            <div class="heading">Guided by Purpose</div>
            <div class="para"><b>Purium</b> isn’t just a company; it’s a movement. Co-founder Dave Sandoval’s guiding philosophy is simple yet profound:</div>
            <div class="quote-text">"The quality of food you eat is equal to the quality of life you live."</div>
            <div class="para">This belief is at the heart of our mission to deliver health, healing, and happiness through pure, premium nutrition.</div>
         </div>
    </div>

    <div class="twelth-section-quality-in-products-purpose-and-opportunity">
         <div class="content">
             <div class="heading mb-4">Quality in Products, Purpose, and Opportunity</div>
             <div class="para mb-4">
                At Purium, quality goes beyond what’s inside our products—it’s woven into everything we do. From clean, nutrient-dense superfoods to a business model rooted in integrity, sustainability, and empowerment, we’re committed to helping people live healthier, happier lives.
             </div>
             <div class="para">
                When you choose Purium, you’re not just nourishing your body—you’re becoming part of a like-minded community that values wellness, impact, and financial freedom. Want to share this mission and earn rewards? Ask the person who introduced you to Purium about getting your own Purium Gift Code and start making a difference today!
             </div>
         </div>
    </div>

    <div class="thirtheenth-section-dave-and-amy-journey">
         <div class="content">
             <div class="left-section">
                 <div class="text mb-4">
                    Dave and Amy’s journey began with a dream—to transform lives through better nutrition. Today, their passion has sparked a global movement of people committed to living cleaner, greener, and healthier lives. Whether you're just beginning your wellness journey or you're a seasoned health enthusiast, Purium is here to support you with premium products and an inspiring community.
                 </div>
                 <div class="text">
                    Join the Movement: Clean, Green, and Healthy LivingWant to learn more? Join us <strong> every Wednesday at 4 PM PT for our Product Education Zoom,</strong> where we dive into the science, benefits, and best practices for optimizing your health with Purium.
                 </div>
                 <div class="container smallScreenPadding view-events-btn mt-4">
                    <a routerLink="/Calendar" class="main-btn ult-btn">
                        <div>view events</div>
                        <img class="" [src]="IMAGE_URL+'/icons/YellowLineArrow.png'" width="50" alt="">
                    </a>
                 </div>
             </div>
             <div class="right-section">
                <img src="assets/images/our-purity-standard/amy-dev-img.png" alt="">
             </div>
         </div>
    </div>

    <div class="fourteenth-section">
        <!-- Left Section -->
        <div class="left-section">
          <img src="assets/images/our-purity-standard/ULT.png" alt="Ultimate Lifestyle Transformation">
          <div class="content-section">
            <h2 class="heading">
              Ultimate Lifestyle <br />
              <span>Transformation</span>
            </h2>
            <p class="mb-4">
              It takes 90 days to create a habit and Purium has the solution. Wake up rejuvenated, feeling energetic all day, and free from bloat and brain fog – without restricting your lifestyle. This program focuses on nourishing your body, not depriving it. Fuel your body with the ULT’s nutrient-rich superfoods. Designed to fit seamlessly into any lifestyle, the ULT makes better health easy and accessible.
            </p>
            <p>
                Not only will you transform your body, but you’ll also dramatically reduce your carbon footprint by making a sustainable, eco-friendly choice. It's the perfect way to nourish yourself and the planet.
            </p>
          </div>
          <div class="container smallScreenPadding start-today-btn mt-5">
            <a routerLink="/Ultlifestyle" class="main-btn ult-btn">
                <div>start today</div>
                <img class="" [src]="IMAGE_URL+'/icons/WhiteLineArrow.png'" width="50" alt="">
            </a>
          </div>
        </div>
      
        <!-- Right Section -->
        <div class="right-section">
          <img src="assets/images/our-purity-standard/ult-demo.png" alt="Superfoods Demo">
          <div class="content-section">
            <h2 class="heading">Share Quality Superfoods & Financial Empowerment</h2>
            <p class="mb-4">
              At Purium, quality isn’t just about the products—it’s about the life you build with them. Every purchase is a step toward better health and a connection to a community of like-minded individuals who are passionate about sustainable, high-quality superfoods and a vibrant way of living.
            </p>
            <p>
                But why stop at transforming your own life? Become a Purium Brand Partner and share the gift of clean nutrition, sustainability, and financial empowerment with others. Join us in making a real impact—on health, the planet, and your future. Ready to start your journey?
            </p>
          </div>
          <div class="container smallScreenPadding enroll-as-bp-today-btn mt-5">
            <a href="https://puriumenrollment.com/Home" class="main-btn ult-btn" target="_blank">
                <div>enroll as a <br> brand partner today</div>
                <img class="" [src]="IMAGE_URL+'/icons/YellowLineArrow.png'" width="50" alt="">
            </a>
          </div>
        </div>
      </div>

</section>
